// extracted by mini-css-extract-plugin
module.exports = {"moreResultsContainer":"Pagination_moreResultsContainer__NskvP","moreResults":"Pagination_moreResults__BsfFV"};